
import 'components/catalog.tag'
import 'pages/products/options/option-new-modal.tag'
import 'pages/products/options/options-items-list.tag'
riot.tag2('options-list', '  <div class="row">\n    <div class="col-md-4">\n      <catalog name="option" object="Option" cols="{colsOption}" handlers="{handlers}" allselect="true" reload="true" sortable="true" reorder="true" store="options-list" filters="{categoryFilters}" add="{permission(add, &quot;products&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;products&quot;, &quot;0001&quot;)}" dblclick="{permission(optionEdit, &quot;products&quot;, &quot;1000&quot;)}">\n        <yield to="filters">\n          <div class="well well-sm">\n            <div class="form-inline">\n              <div class="form-group">\n                <label class="control-label">Группы</label>\n                <select class="form-control" data-name="idGroup" onclick="{parent.selectCategory}">\n                  <option value="">Все</option>\n                  <option each="{category, i in parent.optionCategories}" value="{category.id}" no-reorder>{category.name}</option>\n                </select>\n              </div>\n            </div>\n          </div>\n        </yield>\n        <yield to="body">\n          <datatable-cell name="id">{row.id}</datatable-cell>\n          <datatable-cell name="name">{row.name}</datatable-cell>\n          <datatable-cell name="groupName">{row.groupName}</datatable-cell>\n        </yield>\n      </catalog>\n    </div>\n    <div class="col-md-8 col-xs-12 col-sm-12">\n      <options-items-list name="optionList" filters="{optionFilters}"></options-items-list>\n    </div>\n  </div>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Option';
self.optionFilters = false;
self.optionCategories = [];
//self.categoryFilters = []
self.categoryId = 0;

var getFeaturesTypes = function getFeaturesTypes() {
    API.request({
        object: 'Option',
        method: 'Fetch',
        data: {},
        success: function success(response) {
            self.featuresTypes = response.items;
            self.update();
        }
    });
};

var featureName = function featureName(type) {
    for (var i = 0; i < self.featuresTypes.length; i++) {
        if (self.featuresTypes[i].code === type) return self.featuresTypes[i].name;
    }
};

self.optionEdit = function (e) {
    var item = void 0;

    if (e.item && e.item.row) item = e.item.row;

    modals.create('option-new-modal', {
        type: 'modal-primary',
        item: item,
        submit: function submit() {
            var _this = this;
            var params = _this.item;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'Option',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        self.tags['option'].reload();
                    }
                });
            }
        }
    });
};

self.add = function () {
    if (self.handlers.params.filters != undefined && self.handlers.params.filters.length > 0) self.categoryId = self.handlers.params.filters[0].value;else self.categoryId = 0;
    modals.create('option-new-modal', {
        type: 'modal-primary',
        category: self.categoryId,
        submit: function submit() {
            var _this = this;
            var params = _this.item;
            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'Option',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        self.tags['option'].reload();
                        //self.optionFilters = [{field: 'idOption', sign: 'IN', value}]
                        //self.update()
                        //self.tags['optionList'].tags['optionItem'].reload()
                        _this.modalHide();
                    }
                });
            }
        }
    });
};

self.colsOption = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'groupName', value: 'Группа' }];

self.handlers = {
    featureName: featureName
};

self.one('updated', function () {
    var datatable = self.tags['option'].tags.datatable;
    datatable.on('row-selected', function (count, row) {
        var items = datatable.getSelectedRows();
        if (items.length > 0) {
            var value = items.map(function (i) {
                return i.id;
            }).join(',');
            self.optionFilters = [{ field: 'idOption', sign: 'IN', value: value }];
        } else {
            self.optionFilters = false;
        }
        self.update();
        self.tags['optionList'].tags['optionItem'].reload();
    });
    self.tags['option'].tags.datatable.on('reorder-end', function () {
        var _self$tags$option$pag = self.tags['option'].pages,
            current = _self$tags$option$pag.current,
            limit = _self$tags$option$pag.limit;

        var params = { indexes: [] };
        var offset = current > 0 ? (current - 1) * limit : 0;

        self.tags['option'].items.forEach(function (item, sort) {
            item.sort = sort + offset;
            params.indexes.push({ id: item.id, sort: sort + offset });
        });

        API.request({
            object: 'Option',
            method: 'Sort',
            data: params,
            notFoundRedirect: false
        });

        self.update();
    });
});
self.getOptionGroup = function () {
    API.request({
        object: 'OptionGroup',
        method: 'Fetch',
        success: function success(response) {
            self.optionCategories = response.items;
            self.update();
        }
    });
};

observable.on('options-groups-reload', function () {
    self.tags.catalog.reload();
});

self.getOptionGroup();
});


// WEBPACK FOOTER //
// ./pages/products/options/options-list.tag